/** Оболочка приложения без сети: service worker (public/sw.js). Только в рабочей сборке; без него остальной офлайн работает. */
export function registerShell(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
